import * as React from 'react';
import { connect } from 'react-redux';
import * as urls from '../../shared/urls';
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import moment from 'moment';
import { toast } from 'react-toastify';

import { addOrUpdateUser, getUserAdminInfo } from '../redux-objects/actions';
import UserListUI from './UserListUI';
import UserForm from './UserForm';
import { UserInfo, RoleInfo, Permission } from '../../Login/common/defaults';
import { setUserInfo } from '../../Login/redux-objects/actions';
import Api from '../../../services/Api';
import ToggleSwitch, { ToggleStyle } from '../../shared/ToggleSwitch';

interface IUserAdministrationControllerFromState {
  users: UserInfo[];
  roles: RoleInfo[];
  permissions: Permission[];
  isEditing: boolean;
  serviceURL: string;
  currentUser: UserInfo;
}

interface IUserAdministrationControllerFromActions {
  getUserAdminInfo: (url: string, active: boolean) => Promise<void>;
  addOrUpdateUser: (url: string, user: UserInfo, active: boolean) => Promise<void>;
  setUserInfo: (user: UserInfo) => void;
}

interface UserAdministrationControllerLocalState {
  userToEdit: UserInfo;
  editing: boolean;
  addingUser: boolean;
  showActiveUsers: boolean;
  errors: [];
}

type IUserAdministrationControllerProps = IUserAdministrationControllerFromActions &
  IUserAdministrationControllerFromState;

export class UserAdministrationController extends React.Component<
  IUserAdministrationControllerProps,
  UserAdministrationControllerLocalState
> {
  defaultUserState: UserInfo = {
    id: -1,
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    active: true,
    username: '',
    userRoles: [],
    userPermissions: [],
    loginType: 3,
    lastUpdatedBy: undefined,
    lastUpdated: undefined,
    createdBy: undefined,
    created: undefined
    //isAdmin: UserInfo.prototype.isAdmin,
    //hasPermission: UserInfo.prototype.hasPermission
  };

  constructor(props) {
    super(props);
    this.state = {
      userToEdit: this.defaultUserState,
      editing: false,
      addingUser: false,
      errors: [],
      showActiveUsers: true,
    };
  }
  componentDidMount() {
    this.getUserAdminInfo();
  }

  getUserAdminInfo = () => {
    const { users, roles, serviceURL } = this.props;

    this.props
      .getUserAdminInfo(serviceURL + urls.GET_USER_ADMIN_INFO, this.state.showActiveUsers)
      .catch(error => {
        this.addErrors(error);
      });
  };

  addErrors = error => {
    this.setState(prevErrors => ({
      ...prevErrors,
      error: error
    }));
  };

  handleChange = event => {
    const { name, value } = event.target;
    const { userToEdit } = this.state;
    this.setState(prevState => ({
      userToEdit: {
        ...prevState.userToEdit,
        [name]: value
      }
    }));
  };

  handleSubmit = event => {
    event.preventDefault;
    const { serviceURL } = this.props;
    const { userToEdit } = this.state;
    this.props
      .addOrUpdateUser(serviceURL + urls.ADD_OR_UPDATE_USER, userToEdit, this.state.showActiveUsers)
      .then(() => {
        toast.success('Saved!');
        this.refreshCurrentUser();
      })
      .catch(error => {
        this.addErrors(error);
      });
    this.resetController();
  };

  updateUserChangeInformation() {
    const { currentUser } = this.props;
    this.setState(prevState => ({
      userToEdit: {
        ...prevState.userToEdit,
        lastUpdated: moment().format('yyyy/mm/dd'),
        lastUpdatedBy: currentUser.id
      }
    }));
  }

  handleTogggleChange = ({ toggleIndex, on, label, groupName }) => {
    const { userToEdit } = this.state;

    try {
      if (label === 'Active') {
        this.setState(prevState => ({
          userToEdit: {
            ...prevState.userToEdit,
            active: on
          }
        }));
      } else if (groupName === 'roles') {
        const roleId = toggleIndex;
        const updatedUserRoles = on
          ? this.addNewRoleLink(roleId)
          : this.removeRoleLink(roleId);

        // remove permissions covered by this role
        if (on) {
          const r = this.props.roles.find(x => x.id == roleId);
          r.rolePermissions.map(rp => {
            this.removePermission(rp.permissionId);
          });
        }

        this.setState(prevState => ({
          userToEdit: {
            ...prevState.userToEdit,
            userRoles: updatedUserRoles
          }
        }));
      } else if (groupName === 'permissions') {
        console.log('permission', toggleIndex, on, label);
        const permissionId = toggleIndex;
        const updatedUserPermissions = on
          ? this.addNewPermission(permissionId)
          : this.removePermission(permissionId);
        this.setState(prevState => ({
          userToEdit: {
            ...prevState.userToEdit,
            userPermissions: updatedUserPermissions
          }
        }));
      }
    } catch (er) {
      this.addErrors(er);
    }
  };

  addNewRoleLink = roleId => {
    const { userToEdit } = this.state;
    return [
      ...userToEdit.userRoles,
      {
        roleId: roleId,
        userId: userToEdit.id,
        role: this.props.roles.find(x => x.id == roleId)
      }
    ];
  };

  removeRoleLink = roleId => {
    const { userToEdit } = this.state;
    return userToEdit.userRoles.filter(role => role.roleId !== roleId);
  };

  addNewPermission = permissionId => {
    const { userToEdit } = this.state;
    return [
      ...userToEdit.userPermissions,
      {
        permissionId: permissionId,
        userId: userToEdit.id,
        permission: this.props.permissions.find(x => x.id == permissionId)
      }
    ];
  };

  removePermission = permissionId => {
    const { userToEdit } = this.state;
    return userToEdit.userPermissions.filter(
      up => up.permissionId !== permissionId
    );
  };

  handleClose = () => {
    this.resetController();
  };

  setUserToEdit = (user: UserInfo) => {
    this.setState(prevState => ({
      userToEdit: {
        ...user
      }
    }));
  };

  setEditing = value => {
    this.setState({ editing: value });
  };

  setAddingUser = value => {
    this.setState({ addingUser: value });
  };

  resetEditing = () => {
    this.setEditing(false);
  };

  resetAddingUser = () => {
    this.setAddingUser(false);
  };

  resetUserToEdit = () => {
    this.setState({ userToEdit: new UserInfo() });
  };

  resetErrors = () => {
    this.setState({ errors: [] });
  };

  resetController = () => {
    this.resetEditing();
    this.resetAddingUser();
    this.resetUserToEdit();
    this.resetErrors();
  };

  handleSetUserToEdit = (id: number) => {
    const { users } = this.props;
    if (users.length > 0) {
      const selectedUser = users.find(user => user.id === id);
      this.setUserToEdit({ ...selectedUser });
      this.setEditing(true);
    }
  };

  handleBeginAdding = () => {
    this.setUserToEdit(this.defaultUserState);
    this.setAddingUser(true);
  };

  refreshCurrentUser = async () => {
    const response = await Api.get<{ loggedInUser: UserInfo }>(urls.GET_CID_FROM_AD_URL);
    if (!response.ok || !response.data) {
      console.error({ response });
      return;
    }

    const user = response.data.loggedInUser;

    try {
      const canHang = user.userRoles.some(x => x.roleId == 1);
      let expDate = new Date();
      expDate.setTime(expDate.getTime() + 1800000);
      if (canHang) document.cookie = 'canHang;expires=' + expDate.toUTCString();
    } catch (exception) {
      console.log('Cookie error: ', exception)
    }

    this.props.setUserInfo(user);
  }

  handleToggleShowActiveUsers = ({ toggleIndex, on, label, groupName }) => {
    try {
        this.setState({
          showActiveUsers: on
        }, () => {
          this.getUserAdminInfo();
        });
      
    } catch (er) {
      this.addErrors(er);
    }
  };

  handleRefresh = () => {
    try {        
      this.getUserAdminInfo();      
    } catch (er) {
      this.addErrors(er);
    }
  };

  render() {
    const { users, roles, permissions } = this.props;
    const { userToEdit, editing, addingUser, errors } = this.state;
    const activeToggle = (
      <ToggleSwitch
        on={this.state.showActiveUsers}
        label="Active Users"
        toggle={ToggleStyle.AllowedToEdit}
        key={0}
        toggleIndex={0}
        enabled={true}
        onChange={this.handleToggleShowActiveUsers}
      />
    );
    return (
      <React.Fragment>
        {!editing && !addingUser && users.length <= 0 && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh'
            }}
          >
            <Spinner animation='grow' />
          </div>
        )}

        {!editing && !addingUser && users.length > 0 && (
          <Form.Row>
            <Col xs='6'>
              <Button
                type='button'
                className='btn-primary '
                onClick={this.handleBeginAdding}
              >
                <i className="fa-solid fa-plus"></i>  Add User
              </Button>
              {'    '}
              <Button
                type='button'
                className='btn-primary '
                onClick={this.handleRefresh}
              >
                <i className="fa fa-refresh" aria-hidden="true"></i>  Refresh
              </Button>
            </Col>
            <Col xs='4'></Col>
            <Col xs='2'>
              {activeToggle}
            </Col>
          </Form.Row>
        )}

        {!editing && !addingUser && users.length > 0 && (
          <UserListUI
            users={users}
            selectUserToEdit={this.handleSetUserToEdit}
          />
        )}

        {editing && (
          <UserForm
            user={userToEdit}
            roles={roles}
            permissions={permissions}
            onChange={this.handleChange}
            onSave={this.handleSubmit}
            errors={errors}
            handleClose={this.handleClose}
            showModal={editing}
            onToggleChange={this.handleTogggleChange}
          />
        )}

        {addingUser && (
          <React.Fragment>
            <UserForm
              user={userToEdit}
              roles={roles}
              permissions={permissions}
              onChange={this.handleChange}
              onSave={this.handleSubmit}
              errors={errors}
              handleClose={this.handleClose}
              showModal={addingUser}
              onToggleChange={this.handleTogggleChange}
            />

            <p>Adding</p>
          </React.Fragment>
        )}

        {errors && errors.map(error => <p>{error}</p>)}

        <Row>
          <Button
            type="warning"
            onClick={this.refreshCurrentUser}
          >Refresh Current User</Button>
        </Row>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    users: state.Admin.users,
    roles: state.Admin.roles,
    permissions: state.Admin.permissions,
    optionSelected: state.optionSelected,
    isEditing: state.isEditing,
    serviceURL: state.Application.backendURL,
    currentUser: state.Application.currentUser
  };
}

const mapDispatchToProps = {
  getUserAdminInfo,
  addOrUpdateUser,
  setUserInfo,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserAdministrationController);
